import React, { useState, useMemo, useRef } from "react";
import { getYouTubeVideoId } from "../utils/helpers";
import { ArrowLeftIcon, ArrowRightIcon, PlayIcon } from "./Icons";
import { InlineShareButtons } from "./ShareButton";

const VideosSection = ({ videos, headings, lang }) => {
  const [currentVideo, setCurrentVideo] = useState(videos[0]);
  const [hasInteracted, setHasInteracted] = useState(false);
  const scrollContainerRef = useRef(null);

  const currentVideoId = useMemo(
    () => (currentVideo ? getYouTubeVideoId(currentVideo.youtubeUrl) : null),
    [currentVideo]
  );

  if (!videos || videos.length === 0) {
    return null;
  }

  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
    setHasInteracted(true);
  };

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = scrollContainerRef.current.offsetWidth * 0.8;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="container mx-auto px-4 py-4">
      <h2 className="text-2xl font-bold mb-4 border-b-2 border-red-600 pb-2">
        {headings.videos}
      </h2>
      {currentVideoId && (
        <div className="relative bg-black rounded-lg overflow-hidden mb-6 h-96 md:h-[500px]">
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=${
              hasInteracted ? 1 : 0
            }&controls=1`}
            title={currentVideo.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      )}
      <div className="relative">
        <button
          onClick={() => scroll("left")}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-transform transform hover:scale-110 -ml-4"
        >
          <ArrowLeftIcon />
        </button>
        <div
          ref={scrollContainerRef}
          className="flex space-x-4 overflow-x-auto pb-4 scrollbar-hide"
        >
          {videos.map((video) => {
            const videoId = getYouTubeVideoId(video.youtubeUrl);
            if (!videoId) return null;
            return (
              <div
                key={video.id}
                onClick={() => handleVideoSelect(video)}
                className="group relative rounded-lg overflow-hidden cursor-pointer flex-shrink-0 w-64"
              >
                <img
                  src={`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <PlayIcon />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/80 to-transparent">
                  <p className="text-white text-sm font-semibold leading-tight h-10 overflow-hidden">
                    {video.title}
                  </p>
                  <div className="flex justify-end mt-1" onClick={(e) => e.stopPropagation()}>
                    <InlineShareButtons
                      url={`${window.location.origin}/news/${
                        video.slug || video.id
                      }`}
                      title={video.title}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scroll("right")}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-transform transform hover:scale-110 -mr-4"
        >
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  );
};

export default VideosSection;
